import { useCallback } from 'react';

import { dispatchTrackingEventGA4 } from 'common/tracking/dispatchTrackingEventGA4';

export enum EventName {
  CommonUspTeaserView = 'common-usp-teaser_view',
  CommonUspTeaserClick = 'common-usp-teaser_click',
}

interface UseTrackingEventsProps {
  linkText: string;
  linkUrl: string;
}

export const useTrackingEvents = ({ linkText, linkUrl }: UseTrackingEventsProps) => {
  const onView = useCallback(() => {
    dispatchTrackingEventGA4({
      event: EventName.CommonUspTeaserView,
    });
  }, []);

  const onLinkClick = useCallback(() => {
    dispatchTrackingEventGA4({
      event: EventName.CommonUspTeaserClick,
      element: 'link',
      link_text: linkText,
      link_url: linkUrl,
    });
  }, [linkText, linkUrl]);

  return { onView, onLinkClick };
};
